import { gql } from '@apollo/client';
import { INVENTORY_OPTION_MATCH_FRAGMENT } from 'modules/inventoryOptions';

export const GET_LIST_OF_EQUIPMENT_BY_VO_ID = gql`
  query EquipmentsByVOId($id: ID, $VOId: ID) {
    equipments(id: $id, VOId: $VOId) {
      equipmentId
      vendorOpportunityId
      quantity
      newUsed
      year
      make
      model
      serialNumberVin
      additionalDescription
      stockId
      truckClass
      attachments
      wholesaleCost
      totalWholesaleCost
      retailPrice
      mileage
      assetTypeStr
      classType
      cabType
      term
      lenderProduct
      loanType
      hours
      type
      tradeInValue
      amountOwedOnTradeIn
      equipmentIdx
      discountValue
      discountType
      options {
        ...InventoryOptionMatchFields
      }
    }
  }
  ${INVENTORY_OPTION_MATCH_FRAGMENT}
`;
